import { getApi } from '../Services/apiService';

export const TENANT_DOCUMENTS_REQUIRED_MESSAGE =
  'You need to upload your documents before starting your screening.';

/** API may return a URL string or { url, side, document_type, original_name }. */
export function normalizeDocumentUrl(entry) {
  if (!entry) return '';
  if (typeof entry === 'string') return entry.trim();
  if (typeof entry === 'object' && typeof entry.url === 'string') return entry.url.trim();
  return '';
}

export function normalizeDocumentUrls(entries) {
  if (!Array.isArray(entries)) return [];
  return entries.map(normalizeDocumentUrl).filter(Boolean);
}

export function tenantDocumentsFromApiData(data) {
  if (!data) return false;
  const payStubs = Array.isArray(data.pay_stub_url) ? data.pay_stub_url : [];
  const bankStatements = Array.isArray(data.bank_statement) ? data.bank_statement : [];
  return payStubs.length > 0 && bankStatements.length > 0;
}

export function isTenantDocumentsNotFoundError(error) {
  const statusCode = error?.response?.data?.statusCode ?? error?.response?.status;
  const message = error?.response?.data?.message || '';
  return statusCode === 404 || /documents not found/i.test(message);
}

/** Returns true when tenant has uploaded ID and bank documents. */
export async function tenantHasUploadedDocuments() {
  try {
    const response = await getApi('/auth/get-tenant-documents');
    if (response?.statusCode === 200) {
      return tenantDocumentsFromApiData(response?.data);
    }
    return false;
  } catch (error) {
    if (isTenantDocumentsNotFoundError(error)) return false;
    throw error;
  }
}
